import { useSetAtom } from "jotai";
import { useCallback } from "react";
import { useOpenVisitorModalCallback } from "../../modals/useOpenVisitorModalCallback";
import { videoRoomTokenAtom } from "../../../video-sdk/core/room/state";
import { useAtomCallback } from "jotai/utils";
import { isAdmissionModalOpenAtom } from "./state";
import { ADMITTED_TITLE } from "./metadata";
import { useResetFaviconAndTitleCallback } from "../useResetFaviconAndTitleCallback";

export function useClearAdmissionStateCallback() {
  const setVideoRoomToken = useSetAtom(videoRoomTokenAtom);
  const openVisitorModal = useOpenVisitorModalCallback();
  const getIsAdmissionModalOpen = useAtomCallback(
    useCallback((get) => get(isAdmissionModalOpenAtom), []),
  );
  const resetFaviconAndTitleCallback = useResetFaviconAndTitleCallback();

  return useCallback(() => {
    setVideoRoomToken(undefined);
    if (getIsAdmissionModalOpen()) {
      openVisitorModal(null);
    }
    if (document.title === ADMITTED_TITLE) {
      resetFaviconAndTitleCallback();
    }
  }, [
    setVideoRoomToken,
    getIsAdmissionModalOpen,
    openVisitorModal,
    resetFaviconAndTitleCallback,
  ]);
}
